// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, signInWithCustomToken as firebaseSignInWithCustomToken } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC0j_gwOy4ITOX1k4jXR4AxVbb7LO6Sbvw",
  authDomain: "calcularhidratos.firebaseapp.com",
  projectId: "calcularhidratos",
  storageBucket: "calcularhidratos.appspot.com",
  messagingSenderId: "1087669153319",
  appId: "1:1087669153319:web:b92b67dc3685c1355da802",
  measurementId: "G-TY5RD9PE5M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);

export const loginWithGoogle = async () => {
  try {
    await signInWithPopup(auth, provider);
  } catch (error) {
    console.error("Error al iniciar sesión con Google:", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
    throw error;
  }
};

export const signInWithCustomToken = async (token) => {
  try {
    await firebaseSignInWithCustomToken(auth, token);
  } catch (error) {
    console.error("Error signing in with custom token:", error);
    throw error;
  }
};

// Utility functions for cookies
export const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=None; Secure`;
};

export const getCookie = (name) => {
  return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
};